import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from "recharts";
import { ChartContainer } from "@/components/charts/ChartContainer";
import { formatNumber, formatDate } from "@/utils/format";
import type { InstagramDayPoint } from "@/services/marketing";
import { lineDots, TOOLTIP_CURSOR_BAND } from "@/utils/rechartsInteraction";

interface Props {
  data: InstagramDayPoint[];
  loading?: boolean;
}

function formatChartDate(iso: string): string {
  const raw = (iso ?? "").trim().split("T")[0] ?? "";
  const parts = raw.split("-");
  if (parts.length < 3) return raw;
  return `${parts[2]}/${parts[1]}`;
}

function ReachTooltip({
  active,
  payload,
}: {
  active?: boolean;
  payload?: Array<{ payload?: InstagramDayPoint & { label?: string } }>;
}) {
  if (!active || !payload?.length) return null;
  const row = payload[0]?.payload;
  if (!row) return null;
  return (
    <div className="min-w-[180px] rounded-xl border border-slate-200 bg-white p-3 shadow-modal">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
        {formatDate(row.date)}
      </p>
      <p className="text-sm text-slate-700">
        Alcance: <span className="font-semibold">{formatNumber(row.reach)}</span>
      </p>
    </div>
  );
}

export function InstagramReachByDayChart({ data, loading }: Props) {
  const chartData = data.map((row) => ({
    ...row,
    label: formatChartDate(row.date),
  }));

  return (
    <ChartContainer
      title="Alcance por dia"
      subtitle="Instagram — evolução diária do alcance"
      loading={loading}
      empty={!loading && chartData.length === 0}
      emptyMessage="Sem dados de alcance no período."
    >
      <LineChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
        <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#64748b" }} />
        <YAxis tick={{ fontSize: 11, fill: "#64748b" }} width={48} />
        <Tooltip content={<ReachTooltip />} cursor={TOOLTIP_CURSOR_BAND} />
        <Legend formatter={() => "Alcance"} />
        <Line
          type="monotone"
          dataKey="reach"
          name="reach"
          stroke="#0ea5e9"
          strokeWidth={2}
          {...lineDots("#0ea5e9")}
        />
      </LineChart>
    </ChartContainer>
  );
}
